import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  CardStack,
  Chip,
  ChipRow,
  ContentContainer,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionTitle,
  SplitGrid,
  SurfaceCard,
  SurfaceEyebrow,
  SurfaceText,
  SurfaceTitle,
} from '../styles';

type UniquePositionCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['uniquePosition'];

type UniquePositionSectionProps = {
  copy: UniquePositionCopy;
};

export default function UniquePositionSection({
  copy,
}: UniquePositionSectionProps) {
  return (
    <Section $emphasis>
      <ContentContainer>
        <SplitGrid $reverse>
          <CardStack>
            <SurfaceCard>
              <SurfaceEyebrow>Operating proximity</SurfaceEyebrow>
              <SurfaceTitle>Context built through real working relationships.</SurfaceTitle>
              <ChipRow>
                <Chip>Assets &amp; design</Chip>
                <Chip>Managed marketing</Chip>
                <Chip>Platform development</Chip>
              </ChipRow>
              <SurfaceText>{copy.paragraphs[0]}</SurfaceText>
            </SurfaceCard>
            <SurfaceCard>
              <SurfaceEyebrow>Why it matters</SurfaceEyebrow>
              <SurfaceText>{copy.paragraphs[1]}</SurfaceText>
            </SurfaceCard>
          </CardStack>
          <SectionIntro>
            <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
            <SectionTitle>{copy.title}</SectionTitle>
          </SectionIntro>
        </SplitGrid>
      </ContentContainer>
    </Section>
  );
}
